import type { WebTagssGlobalSearchOutputDto } from '@bldsoft/ovp-api-types'
import type { Search, SearchSuggestion } from '@setplex/tria-api'
import { format as formatContent } from '../content/format'
import { format as formatCreator } from '../creators/format'
import { format as formatChannel } from '../live/format'
import type { ApiLiveChannelSuggestionItem } from '../live/index.h'
import { format as formatTvShow } from '../tvshows/format'
import type { ApiTvShowSuggestionItem } from '../tvshows/index.h'
import type { ApiSearch, ApiSearchSuggestion } from './index.h'

/**
 * The spec types suggestion tv shows as `TvShowSearchListItemOutputDto` and
 * suggestion channels as `WebLiveChannelGlobalSearchItemOutputDto`, but
 * `/api/web/search/suggestion` sends tv shows without `creator`, `isFavorite`
 * and `languages`, and channels without `isFavorite`. Accept both shapes here —
 * the suggestion items are the wider of the two, so a spec-conformant payload
 * still fits.
 */
type ApiSearchSuggestionPayload = Omit<
  ApiSearchSuggestion,
  'channels' | 'tvShows'
> & {
  readonly channels: readonly ApiLiveChannelSuggestionItem[]
  readonly tvShows: readonly ApiTvShowSuggestionItem[]
}

const formatSearchTag = ({
  id,
  title,
  horizontalImage,
}: WebTagssGlobalSearchOutputDto) => ({
  id,
  title,
  horizontalImage,
})

export const format = ({
  creators,
  contents,
  channels,
  tvShows,
}: ApiSearch): Search => ({
  creators: creators?.length ? [...creators].map(formatCreator) : [],
  contents: contents?.length ? [...contents].map(formatContent) : [],
  channels: channels?.length ? [...channels].map(formatChannel) : [],
  tvShows: tvShows?.length ? [...tvShows].map(formatTvShow) : [],
})

export const formatSuggestion = ({
  creators,
  contents,
  channels,
  tvShows,
}: ApiSearchSuggestionPayload): SearchSuggestion => ({
  creators: creators?.length ? [...creators].map(formatCreator) : [],
  contents: contents?.length ? [...contents].map(formatContent) : [],
  channels: channels?.length ? [...channels].map(formatChannel) : [],
  tvShows: tvShows?.length ? [...tvShows].map(formatTvShow) : [],
})

export { formatSearchTag }
